'use client'

import { formatDateNormal, formatImageURL } from "@/utils/util"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"

export const BLOG_IMAGE_ASPECT = 'aspect-19/10'

export default function BlogCard({ blog }: { blog: any, index?: number }) {
  const pathname = usePathname()
  return (
    <a href={navigateUrl(`/blog/${blog.id}`, pathname)} className="group block focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-foreground">
      <div className={`${BLOG_IMAGE_ASPECT} bg-muted overflow-hidden`}>
        <img src={formatImageURL(blog.thumbnail || 'placeholder.png')} alt="" loading="lazy" className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-90" />
      </div>
      <div className="px-4 lg:px-10 pt-6 pb-10">
        <h3 className="text-lg sm:text-xl leading-snug tracking-tight text-foreground line-clamp-2">
          <span className="pb-0.5 bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-position-[0_100%] bg-size-[0%_1px] group-hover:bg-size-[100%_1px] transition-[background-size] duration-500 ease-out motion-reduce:transition-none box-decoration-clone">{blog.title}</span>
        </h3>
        <time className="mt-3 block text-sm text-muted-foreground tabular-nums">{formatDateNormal(new Date(blog.createdAt))}</time>
      </div>
    </a>
  )
}
